import type { InventoryItem } from '@app/types/shop-bff/types';

/**
 * Flattens nested `inventoryItem.attributes` object array from
 * [{ name: string, value: string, attributes: { name: string, value: any } }, ...]
 * to
 * { [input[0].name]: input[0].value, .. }
 *
 * eg.
 *
 * Input:
 * [
 *    {
 *        "name": "size",
 *        "value": "large",
 *        "attributes": [
 *            ...
 *        ]
 *    },
 *    {
 *        "name": "bodyColor",
 *        "value": "forest_green",
 *        "attributes": [
 *            ...
 *        ]
 *    },
 *    {
 *        "name": "printLocation",
 *        "value": "back",
 *        "attributes": [
 *            ...
 *        ]
 *    }
 * ]
 *
 * Output:
 * { size: "large", bodyColor: "forest_green", printLocation: "back" }
 */
export const mapLegacyAttributes = ({
  attributes,
}: {
  attributes: Array<Record<string, any>>;
}): Array<Record<string, string | number>> | {} => {
  return attributes.reduce((acc, attr) => {
    if (attr.name) {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});
};

/**
 * Returns discounted price amount if discount is applicable.
 */
export const getItemValue = (
  price: NonNullable<InventoryItem['price']>
): number => {
  if (price.discount && price.discount.percent > 0)
    return price.discount.amount;

  return price.amount;
};
